import classNames from 'classnames';
import './index.scss';
export interface EcoSpaceProps {
    /**
     * 主题色
     */
    theme?: 'white' | 'black' | 'white2';
    /**
     * 高度-pc
     */
    hPc?: string;
    /**
     * 高度-pad
     */
    hPad?: string;
    /**
     * 高度-h5
     */
    hH5?: string;
    /**
     * 背景色
     */
    bgColor?: string;
    /**
     * 样式类
     */
    className?: string;
}

/**
 * 上下间隔
 */
export default function EcoSpace({ theme, hPc, hPad, hH5, bgColor, className }: EcoSpaceProps) {
    const prefixCls = 'eco-space';
    const compCls = classNames(prefixCls, {
        [`${className}`]: className,
        [`${prefixCls}-theme-${theme}`]: theme,
    });

    const compStyle = {
        '--space-h-pc': hPc,
        '--space-h-pad': hPad,
        '--space-h-h5': hH5,
        '--space-bg': bgColor,
    } as React.CSSProperties;

    return <div className={compCls} style={compStyle}></div>;
}
